export default class SelectC8 {
  constructor() {
    this.$callSelectC8 = $('.select-c8');
    this.callSelectC8Option = '.select-c8 option';
    this.formSelectC8 = '.form-select-c8';
    this.dropdownSelectC8 = 'dropdown-select-c8';
    this.dropdownMenu = '.dropdown-menu';
    this.arrow = '<span class="caret-c8 icomoon icon-chevron-down"></span>';
    this.dropdownOpen = `.dropdown-select-c8.show, ${this.dropdownMenu}.show`;
    this.title = '';
    this.ariaSelected = 'aria-selected';
    this.ariaExpanded = 'aria-expanded';
    this.ulListBox = 'ul[role="listbox"]';
    this.dropToggle = '.dropdown-toggle';
    this.hidden = 'hidden';
    this.show = 'show';
    this.liSelected = 'li.selected';
    this.liOptionSelected = 'li.optiton-select';
    this.focusSelect = '[role="combobox"], li.optiton-select';
    this.textSelected = 'selected';
    this.ariaActivedescendant = 'aria-activedescendant';
    this.searchString = '';
    this.clsDropdownToggle = '.dropdown-toggle .filter-option';
    this.clsAcitveFocus = 'active-focus';
  }

  init() {
    if (this.$callSelectC8.length) {
      $(document).off('click', this.dropToggle)
      $(document).off('click', '.dropdown-select-c8 li')
      $(document).off('click', this.clickOutClose)
      $(document).off('keyup')
      $(document).off('keydown', this.focusSelect)
      this.renderSelectToDropdown();
      this.clickToggle();
      this.clickSelect();
      this.changeSelectC8();
      this.hoverLiRemoveClass();
      this.clickOutClose();
      this.keyOption();
      this.roleSelectDropdownCloseAction();
      this.searchCharacterSelectbox();
    }
  }

  renderHtml(element, textTitle) {
    const randomId = Math.floor(Math.random() * 10e9);
    let idSelect = element.id || randomId;
    idSelect = `id-${idSelect}`;
    const $label = $(element).prevAll('label');
    let labelingAttrs = '';
    if ($label.length) {
      let labelId = $label.get(0).id;
      if (!labelId) {
        labelId = `id-${randomId}-label`;
        $label.attr('id', labelId);
      }
      labelingAttrs = `aria-labelledby="${labelId}"`;
    } else {
      const fallbackLabel = $(element).attr('aria-label') ||
        $(element).attr('title') ||
        $(element).data('title') ||
        $(element).find('option').first().text() ||
        'Select';
      labelingAttrs = `aria-label="${fallbackLabel}"`;
    }

    const eleParent = $(element).parent();
    const isFormContact = $(element).closest('.gg-gravity-form').length > 0
    const firstOptionText = $(element).find('option').first().text()
    const displayTitle = (isFormContact && !textTitle) ? firstOptionText : textTitle
    eleParent.find('.dropdown').remove();
    eleParent.after().append(`<div class='dropdown ${this.dropdownSelectC8}'>
          <div class='dropdown-toggle form-control'
           role='combobox' data-toggle='dropdown' aria-haspopup='listbox' aria-expanded="false" aria-controls="${idSelect}" ${labelingAttrs} ${this.ariaActivedescendant} tabindex="0">
          <span class="filter-option">${displayTitle}</span>${this.arrow}</div>
          <div class='dropdown-menu dropdown-menu-c8 hidden'>
          <ul role="listbox" id="${idSelect}" ${labelingAttrs} class="select-c8__ul"></ul>
          </div>
        </div>`);
    $(element).each((_idx, elm) => {
      let disabled = '';
      let hiddenText = '';

      $(element)
        .find('option', elm)
        .each((id, el) => {
          let selected = '';
          if ($(el).prop('disabled')) {
            disabled = 'disabled';
            hiddenText = `<span class="sr-only">&nbsp; disabled</span>`;
          }
          if ($(el).attr('selected')) {
            selected = 'selected';
          }
          const optionValue = el.value;
          eleParent.find('.dropdown ul').append(`
          <li ${disabled} tabindex="0"
            class="${disabled} ${selected} optiton-select"
            role="option"
            data-value="${optionValue}"
            aria-selected="${$(el).attr('selected') ? 'true' : 'false'}"
            id="combo-${idSelect}-${id}">
            <span ${disabled} class="${disabled}">
              ${el.text} ${hiddenText}</span>
          </li>`);
          disabled = '';
          hiddenText = '';
        });
    });
  }

  titleUndefined(element) {
    this.title = $(element).data('title');
    if (typeof this.title === 'undefined') {
      let indexActive = 0;
      $(element)
        .children('option')
        .each((_indexChild, elementChild) => {
          if (typeof $(elementChild).attr('selected') !== 'undefined') {
            this.title = $(elementChild).text();
            indexActive = $(elementChild).index();
          }
        });
      if (indexActive === 0) {
        const isFormContact = $(element).closest('.gg-contact-form').length > 0
        if (!isFormContact) {
          this.title = $(element).find('option').first().attr('selected', 'selected').text()
        }
      }
    }
    return this.title;
  }

  renderSelectToDropdown() {
    this.$callSelectC8.each((_index, element) => {
      if (!$(element).hasClass('select-done')) {
        this.title = $(element).data('title');
        this.titleUndefined(element);
        this.renderHtml(element, this.title);
        $(element).addClass('select-done');

        // Check if there's a selected value and add active-focus class
        const dropParent = $(element).parents(this.formSelectC8);
        const isGravityForm = $(element).closest('.gg-gravity-form').length > 0;
        const hasSelectedOption = $(element).find('option[selected]').length > 0;
        const $selectedOption = $(element).find('option[selected]').first();
        const selectedValue = $selectedOption.val();
        const $filterOption = dropParent.find(this.clsDropdownToggle);
        const firstOptionText = $(element).find('option').first().text();

        // Add active-focus if there's a selected option and it's not the first option (placeholder)
        if (hasSelectedOption && $selectedOption.index() > 0) {
          dropParent.addClass(this.clsAcitveFocus);
          // Keep the text as is
        } else if (hasSelectedOption && selectedValue && selectedValue !== '') {
          // Or if first option has value (not empty placeholder)
          dropParent.addClass(this.clsAcitveFocus);
          // Keep the text as is
        } else {
          // No value selected — use data-title if present, otherwise first option text
          const dataTitle = $(element).data('title');
          $filterOption.text(dataTitle || firstOptionText);
          dropParent.removeClass(this.clsAcitveFocus);
        }

        this.title = '';
      }
    });
  }

  clickToggle() {
    $(document).on('click', this.dropToggle, (e) => {
      const $dropdownRemove = $(`${this.dropdownMenu}, .dropdown-select-c8`);
      const ele = e.currentTarget;
      const eleParent = $(ele).parent();
      const eleParents = eleParent.find(this.dropdownMenu);
      if (eleParent.hasClass(this.show)) {
        $dropdownRemove.removeClass(this.show);
        eleParent.removeClass(this.show);
        eleParents.addClass(this.hidden);
        $(ele).attr(this.ariaExpanded, false);
        $(ele).parents(this.formSelectC8).find(this.dropToggle).attr(this.ariaActivedescendant, '');
        this.focusCombobox($(ele));
      } else {
        $dropdownRemove.removeClass(this.show);
        $(this.formSelectC8).find(this.dropdownMenu).addClass(this.hidden);
        eleParent.addClass(this.show);
        eleParents.removeClass(this.hidden);
        $(ele).attr(this.ariaExpanded, true);
      }
      return false;
    });
  }

  multiSelect(ele, index) {
    const dropParent = $(ele).parents(this.formSelectC8);
    const selected = 'selected';
    const selectedDisable = 'li.selected:not(.disabled)';
    let string = '';
    if ($(ele).hasClass(selected)) {
      $(ele).removeClass(selected).addClass('not-hover').attr(this.ariaSelected, false);
      $(ele).parents(this.formSelectC8).find(this.callSelectC8Option).eq(index).removeAttr(selected);
      if ($(ele).parents('ul').find(selectedDisable).length < 1) {
        string = `${$(ele).parents('ul').find('li.selected:not(.disabled)').text().trim()}, `;
      }
    } else {
      $(ele).addClass(selected).removeClass('not-hover').attr(this.ariaSelected, true);
    }

    $(ele)
      .parents('ul')
      .find(selectedDisable)
      .each((indexLI, el) => {
        // index = indexLI
        const value = $(el).text().trim();
        string += `${value}${indexLI + 1 === $(ele).parents('ul').find(selectedDisable).length ? '' : ', '}`;
      });
    if (!$(ele).parents(`.${this.dropdownSelectC8}`).hasClass('no-trigger-active')) {
      $(ele)
        .parents(`.${this.dropdownSelectC8}`)
        .find(this.clsDropdownToggle)
        .text(string.slice(0, string.length - 2));
    }
    dropParent.find(this.callSelectC8Option).prop(selected, false);
    setTimeout(() => {
      $.each(string.split(', '), (_i, e) => {
        dropParent.find(`.select-c8 option[value="${e}"]`).attr(selected, selected);
      });
      dropParent.find(this.$callSelectC8).val(string.split(', ')).change();

      // Add active-focus class when value is selected
      const selectedValues = string.split(', ').filter((v) => v !== '');
      if (selectedValues.length > 0 && selectedValues[0] !== '') {
        dropParent.addClass(this.clsAcitveFocus);
      } else {
        dropParent.removeClass(this.clsAcitveFocus);
      }
    }, 100);

    return false;
  }

  singleSelect(ele, index) {
    const text = $(ele).text();
    if (!$(ele).hasClass('disabled')) {
      $(ele).parents('ul').find('li').removeClass('selected').attr(this.ariaSelected, false);
      $(ele).addClass('selected').attr(this.ariaSelected, true);
      const dropParent = $(ele).parents(this.formSelectC8);
      setTimeout(() => {
        dropParent
          .find(this.callSelectC8Option)
          .removeAttr('selected')
          .eq(index)
          .attr('selected', 'selected')
          .prop('selected', true);
        const liDataValue = $(ele).data('value');
        const val = (liDataValue !== undefined && liDataValue !== null)
          ? liDataValue
          : dropParent.find(this.callSelectC8Option).eq(index).val();
        dropParent.find(this.$callSelectC8).val(val).change();
        $(ele).parents(`${this.dropdownMenu}, .dropdown-select-c8`).removeClass(this.show);
        $(ele).parents(this.dropdownMenu).addClass(this.hidden);
        dropParent.find(this.dropToggle).attr(this.ariaActivedescendant, '');

        // Update filter-option text: always show text, toggle active-focus by value
        if (!$(ele).parents(`.${this.dropdownSelectC8}`).hasClass('no-trigger-active')) {
          $(ele).parents(`.${this.dropdownSelectC8}`).find(this.clsDropdownToggle).text(text);
          if (val && val !== '') {
            dropParent.addClass(this.clsAcitveFocus);
          } else {
            dropParent.removeClass(this.clsAcitveFocus);
          }
        } else {
          // Add/remove active-focus class even when no-trigger-active
          // eslint-disable-next-line no-lonely-if
          if (val && val !== '') {
            dropParent.addClass(this.clsAcitveFocus);
          } else {
            dropParent.removeClass(this.clsAcitveFocus);
          }
        }
      }, 100);
    }
  }

  clickSelect() {
    $(document).on('click', '.dropdown-select-c8 li', (e) => {
      const ele = e.currentTarget;
      const index = $(ele).index();
      const formGroup = $(ele).parents('.form-group');
      if (formGroup.length && formGroup.hasClass('error')) {
        formGroup.removeClass('error');
      }
      if (formGroup.length && formGroup.hasClass('gfield_error')) {
        formGroup.removeClass('gfield_error');
      }
      $(`.${this.dropdownSelectC8}`).removeClass('focus');
      $(ele).parents('.form-control').find(this.dropToggle).addClass('active');
      $(ele).parents('.dropdown-select-c8').find(this.dropToggle).attr(this.ariaExpanded, 'false');
      $(ele).parents('ul').find('li').removeClass('focus');
      if ($(ele).parents(this.formSelectC8).hasClass('multiselect')) {
        this.multiSelect(ele, index);
      } else {
        this.singleSelect(ele, index);
        this.focusCombobox($(ele));
      }
    });
  }

  hoverLiRemoveClass() {
    $(`.${this.dropdownSelectC8}`)
      .find('li')
      .on('hover', () => {
        $(`.${this.dropdownSelectC8}`).find('li').removeClass('not-hover').blur();
      });
  }

  changeSelectC8() {
    this.$callSelectC8.change(() => {
      this.$callSelectC8.trigger('changeSelect');
    });
  }

  clickOutClose() {
    $(document).click((event) => {
      if (!$(event.target).closest('.dropdown-select-c8.show, .dropdown-menu.show, .dropdown-select-c8 *').length) {
        $(this.formSelectC8).find(this.dropdownMenu).addClass(this.hidden);
        $(this.dropdownOpen).find(this.dropToggle).attr(this.ariaExpanded, false);
        $(this.dropdownOpen).removeClass(this.show);
        $(this.dropToggle).attr(this.ariaActivedescendant, '');
      }
    });
  }

  closeDropdown() {
    $(this.dropdownOpen).find(this.dropToggle).attr(this.ariaExpanded, false);
    $(this.dropdownOpen).removeClass(this.show);
    $(this.formSelectC8).find(this.dropdownMenu).addClass(this.hidden);
    $(this.dropToggle).attr(this.ariaActivedescendant, '');
  }

  focusCombobox($ele) {
    $ele.parents(`.${this.dropdownSelectC8}`).find(this.dropToggle).focus();
  }

  keyOption() {
    $(document).keyup((e) => {
      if (e.keyCode === 27 && $('.dropdown-select-c8.show').length) {
        this.closeDropdown();
      }
      window.addEventListener(
        'keydown',
        (keydownEvent) => {
          // space and arrow keys
          if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1 && $('.dropdown-select-c8.show').length) {
            keydownEvent.preventDefault();
          }
        },
        false,
      );
    });
  }

  isElementInView(element) {
    if (element) {
      const bounding = element.getBoundingClientRect();
      const $select = $('.dropdown-menu.dropdown-menu-c8');
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= $select.innerHeight() &&
        bounding.right <= $select.innerWidth()
      );
    }
    return true;
  }

  scrollToScreen($liCurrent) {
    if ($liCurrent[0] && !this.isElementInView($liCurrent[0])) {
      $liCurrent[0].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }

  openDropDown($ele) {
    const $dropdownRemove = $('.dropdown-menu, .dropdown-select-c8');
    const eleParent = $ele.parent();
    const eleParents = eleParent.find(this.dropdownMenu);
    $(this.formSelectC8).find($dropdownRemove).removeClass(this.show);
    eleParent.addClass(this.show);
    eleParents.removeClass(this.hidden);
    $ele.attr(this.ariaExpanded, 'true');
  }

  selectedNext($ele) {
    const $tabIndex0 = $ele.parents(`.${this.dropdownSelectC8}`).find('li');
    let focusIndex = $ele.parent().find('li.focus').index() + 1;
    $ele.parent().find('li.focus').removeClass('focus');
    if ($tabIndex0.eq(focusIndex).hasClass('disabled')) {
      focusIndex++;
    }
    $tabIndex0.eq(focusIndex).addClass('focus').focus();
    $ele
      .parents(`.${this.dropdownSelectC8}`)
      .find(this.dropToggle)
      .attr(this.ariaActivedescendant, $tabIndex0.eq(focusIndex).attr('id'));
    this.scrollToScreen($tabIndex0.eq(focusIndex));
  }

  selectedPrev($ele) {
    const $tabIndex0 = $ele.parents(`.${this.dropdownSelectC8}`).find('li');
    let focusIndex = $ele.parent().find('li.focus').index() - 1;
    $ele.parent().find('li.focus').removeClass('focus');
    if ($tabIndex0.eq(focusIndex).hasClass('disabled')) {
      focusIndex--;
    }
    $tabIndex0.eq(focusIndex).addClass('focus').focus();
    $ele
      .parents(`.${this.dropdownSelectC8}`)
      .find(this.dropToggle)
      .attr(this.ariaActivedescendant, $tabIndex0.eq(focusIndex).attr('id'));
    this.scrollToScreen($tabIndex0.eq(focusIndex));
  }

  handlePgDnSelectDropdown(index, indexLiLast, $ele, e) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show)) {
      e.preventDefault();
      const indexRemain = indexLiLast - index;
      if (index !== indexLiLast && indexRemain >= 10) {
        this.selectedNext($ele);
      } else {
        this.selectedNext($ele);
      }
    }
  }

  handlePgUpSelectDropdown(index, indexLiFirst, $ele, e) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show)) {
      e.preventDefault();
      const indexRemain = index - indexLiFirst;
      if (index !== indexLiFirst && indexRemain >= 10) {
        this.selectedPrev($ele);
      } else {
        this.selectedPrev($ele);
      }
    }
  }

  handleSpaceAndEnterDropdown(eleParent, eleParents, $dropdownRemove, $ele, multi) {
    const $textSelected = $ele.parent().find('li.focus');
    if (eleParent.hasClass(this.show)) {
      $($textSelected).trigger('click');
      if (!multi) {
        eleParent.removeClass(this.show);
        eleParents.addClass(this.hidden);
        $ele.attr(this.ariaExpanded, false);
        $ele.parents(this.formSelectC8).find(this.dropToggle).attr(this.ariaActivedescendant, '');
      }
    } else {
      $dropdownRemove.removeClass(this.show);
      eleParent.addClass(this.show);
      eleParents.removeClass(this.hidden);
      $ele.attr(this.ariaExpanded, true);
    }
  }

  handleArrowUpDropdown($ele) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show)) {
      this.selectedPrev($ele);
    } else {
      this.openDropDown($ele);
    }
  }

  handleArrowDownDropdown(index, indexLiLast, $ele) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show) && index !== indexLiLast) {
      this.selectedNext($ele);
    } else {
      this.openDropDown($ele);
    }
  }

  handleHomeSelectDropdown(eleParents, $liFirst, $tabIndex0, indexLiFirst, $ele) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show)) {
      eleParents.find('li.focus').removeClass('focus');
      $liFirst.addClass('focus').focus();
      this.scrollToScreen($tabIndex0.eq(indexLiFirst));
    } else {
      this.openDropDown($ele);
    }
  }

  handleEndSelectDropdown(eleParents, $liLast, $tabIndex0, indexLiLast, $ele) {
    if ($(`.${this.dropdownSelectC8}`).hasClass(this.show)) {
      eleParents.find('li.focus').removeClass('focus');
      $liLast.addClass('focus').focus();
      this.scrollToScreen($tabIndex0.eq(indexLiLast));
    } else {
      this.openDropDown($ele);
    }
  }

  roleSelectDropdownCloseAction() {
    $(document).on('keydown', this.focusSelect, (e) => {
      const code = e.keyCode;
      const ele = e.currentTarget;
      const $liFirst = $(ele).parent().find('li:first');
      const $liLast = $(ele).parent().find('li:last');
      const $liSelected = $(ele).parent().find(this.liSelected);
      const $tabIndex0 = $(ele).parents(`.${this.dropdownSelectC8}`).find('li');
      const index = $tabIndex0.index($liSelected);
      const indexLiFirst = $tabIndex0.index($(ele).parent().find('li:first'));
      const indexLiLast = $tabIndex0.index($(ele).parent().find('li:last'));
      const $dropdownRemove = $('.dropdown-menu, .dropdown-select-c8');
      const eleParent = $(ele).parents(`.${this.dropdownSelectC8}`);
      const eleParents = eleParent.find(this.dropdownMenu);
      const multi = $(ele).parents(this.formSelectC8).hasClass('multiselect');
      switch (code) {
        case 9:
          this.handleCode9HasClassShow(eleParent, eleParents, $dropdownRemove, $(ele));
          break;
        case 34:
          this.handlePgDnSelectDropdown(index, indexLiLast, $(ele), e);
          break;
        case 33:
          this.handlePgUpSelectDropdown(index, indexLiFirst, $(ele), e);
          break;
        case 13:
        case 32:
          e.preventDefault();
          this.handleSpaceAndEnterDropdown(eleParent, eleParents, $dropdownRemove, $(ele), multi);
          break;
        case 38:
          e.preventDefault();
          this.handleCode38HasAltKey(eleParent, eleParents, $dropdownRemove, $(ele), e);
          break;
        case 40:
          e.preventDefault();
          this.handleArrowDownDropdown(index, indexLiLast, $(ele));
          break;
        case 36:
          e.preventDefault();
          this.handleHomeSelectDropdown(eleParents, $liFirst, $tabIndex0, indexLiFirst, $(ele));
          break;
        case 35:
          e.preventDefault();
          this.handleEndSelectDropdown(eleParents, $liLast, $tabIndex0, indexLiLast, $(ele));
          break;
        default:
          break;
      }
    });
  }

  handleCode9HasClassShow(eleParent, eleParents, $dropdownRemove, ele) {
    if (eleParent.hasClass('show')) {
      this.handleSpaceAndEnterDropdown(eleParent, eleParents, $dropdownRemove, $(ele));
    } else {
      this.closeDropdown();
    }
  }

  handleCode38HasAltKey(eleParent, eleParents, $dropdownRemove, ele, e) {
    if (e.altKey) {
      this.handleSpaceAndEnterDropdown(eleParent, eleParents, $dropdownRemove, $(ele));
    } else {
      this.handleArrowUpDropdown($(ele));
    }
  }

  searchCharacterSelectbox() {
    $(document).on('keydown', this.focusSelect, (ev) => {
      const $target = $(ev.currentTarget);
      const $parent = $target.parents(`.${this.dropdownSelectC8}`);
      const $listbox = $parent.find('[role="listbox"]');
      const $listOptions = $parent.find(this.liOptionSelected);
      const code = ev.keyCode || ev.which;
      const char = ev.key;
      const options = [];
      let searchOptions = [];
      let indexGoto = -1;
      const searchString = this.getSearchString(char);
      const indexActive = $parent.find(`.${this.textSelected}`).index() + 1;
      if ((code > 64 && code < 91) || (code > 47 && code < 58)) {
        if ($parent.find('.dropdown-menu-c8').hasClass(this.hidden)) {
          this.openDropDown($target);
        }
        $listOptions.each((_idx, elm) => {
          options.push($(elm).text().trim());
        });
        const orderedOptions = options.slice(indexActive).concat(options.slice(0, indexActive));
        const allSameLetter = (array) => array.every((letter) => letter === array[0]);
        searchOptions = orderedOptions.filter((opt) => opt.toLowerCase().indexOf(searchString.toLowerCase()) === 0);
        const firstMatch = searchOptions[0];
        if (firstMatch) {
          indexGoto = options.indexOf(firstMatch);
        } else if (allSameLetter(searchString.split(''))) {
          searchOptions = orderedOptions.filter(
            (opt) => opt.toLowerCase().indexOf(searchString[0].toLowerCase()) === 0,
          );
          indexGoto = options.indexOf(searchOptions[0]);
        } else {
          indexGoto = -1;
        }
        if (indexGoto > -1) {
          this.maintainScrollVisibility($listOptions[indexGoto], $listbox.parent()[0]);
          $listOptions.removeClass('focus');
          $listOptions.eq(indexGoto).addClass('focus').focus();
          const LiActive = $(`.${this.dropdownSelectC8}`).find('li.focus');
          $target.attr(this.ariaActivedescendant, LiActive.attr('id'));
        }
      }
    });
  }

  maintainScrollVisibility(activeElement, scrollParent) {
    const { offsetHeight, offsetTop } = activeElement;
    const { scrollTop, offsetHeight: parentOffsetHeight } = scrollParent;
    const isAbove = offsetTop < scrollTop;
    const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
    if (isAbove) {
      scrollParent.scrollTo(0, offsetTop);
    }
    if (isBelow) {
      scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
  }

  getSearchString(char) {
    if (typeof this.searchTimeout === 'number') {
      window.clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = window.setTimeout(() => {
      this.searchString = '';
    }, 500);
    this.searchString += char;
    return this.searchString;
  }
}

// Global instance - export for use in other modules
export const globalSelectC8 = new SelectC8()
globalSelectC8.init()
